import React from 'react';

import { i18n } from './i18n';

import * as css from './intro.module.css';

export default function Intro() {
    return (<div className={css.intro}>
        <h1 className={css.title}>{i18n('title')}</h1>
        <p className={css.introCopy}>{i18n('intro')}</p>
    </div>);
}
